import { Record } from "immutable";

export type CourseStatType = {
  courseId: string;
  sessionsCompleted: number;
  totalStudyTime: number;
  lastStudied: string | null | undefined;
  sessionModulesStudied: number;
  proficiency: number;
  score: number;
  // DEPRECATED
  numberOfNotesOnlySessions: number;
};

export type OptionalCourseStatType = Partial<CourseStatType>;

export default class CourseStat extends Record({
  courseId: undefined,
  sessionsCompleted: 0,
  totalStudyTime: 0,
  lastStudied: null,
  sessionModulesStudied: 0,
  proficiency: 0,
  score: 0,
  // DEPRECATED
  numberOfNotesOnlySessions: 0
}) {}
